module.exports = __webpack_public_path__ + "img/food-hero-econom-s.848979a8.jpg";